<template>
  <div class="partner-form p-top-7">
    <div class="container p-bot-1 p-top-4 row-80-20 max">
      <div class="left">
        <h2 class="heading-1 title">
          Arricchisci la tua offerta, diventa partner
        </h2>
      </div>
      <div class="right">
        <FormPartner />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerForm',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
